// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Components
import Row from 'ui/Row'
import Col from 'ui/Col'
import Media from 'ui/Media'
import Text from 'ui/Text'
import Button from 'ui/Button'
import Link from 'ui/Link'
import HTMLViewer from 'ui/HTMLViewer'

// Models
import Notification from 'models/Notification'

// Paths
import {
  PATH_ANNOUNCEMENT_VIEW,
  PATH_ECWT_VIEW,
  PATH_PAYMENT_CONTRACT,
  PATH_PAYMENT_VIEW,
  PATH_TICKET_VIEW,
} from 'routes/paths'

export const NotificationItem = ({ notification }) => {
  // Notification
  const {
    id,
    icon,
    title,
    displayDate,
    isRead,
    isEcwt,
    isPayment,
    isContractExpiration,
    isTicketComment,
    isTicketConfirm,
    isAnnouncement,
  } = notification

  // Show content notification
  const renderContent = () => {
    if (isPayment || isContractExpiration) {
      return (
        <>
          <Row>
            <Col xs={6} md={4}>
              Lessor name:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.lessorName}</Text>
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={4}>
              Company code:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.companyCode}</Text>
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={4}>
              Vendor code:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.vendorCode}</Text>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col xs={6} md={4}>
              Contract no:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.contractNumber}</Text>
            </Col>
          </Row>
        </>
      )
    }

    if (isTicketComment || isTicketConfirm) {
      return (
        <>
          <Row>
            <Col xs={6} md={4}>
              Ticket no.:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.ticketNo}</Text>
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={4}>
              Date raised:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.raisedAt}</Text>
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={4}>
              Issue category:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.issueCategory}</Text>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col xs={6} md={4}>
              Issue type:
            </Col>
            <Col xs={6} md={8}>
              <Text color="#000000">{notification.issueType}</Text>
            </Col>
          </Row>
        </>
      )
    }

    if (isAnnouncement) {
      return (
        <>
          <Text color="#000000">{notification.subject}</Text>
          <HTMLViewer
            data={notification.content}
            truncate={140}
            color="#606060"
            padding={0}
          />
        </>
      )
    }

    return null
  }

  const resolveRouter = () => {
    if (isPayment) {
      return {
        path: PATH_PAYMENT_VIEW,
        params: {
          companyCode: notification.companyCode,
          vendorCode: notification.vendorCode,
          contractNumber: notification.contractNumber,
          paymentMethod: notification.paymentMethod,
          paymentId: notification.mappingId,
        },
        query: {
          notificationId: id,
        },
      }
    }

    if (isEcwt) {
      return {
        path: PATH_ECWT_VIEW,
        params: {
          id: notification.mappingId,
        },
        query: {
          notificationId: id,
        },
      }
    }

    if (isTicketComment || isTicketConfirm) {
      return {
        path: PATH_TICKET_VIEW,
        params: {
          id: notification.mappingId,
        },
        query: {
          notificationId: id,
        },
      }
    }

    if (isContractExpiration) {
      return {
        path: PATH_PAYMENT_CONTRACT,
        params: {
          companyCode: notification.companyCode,
          vendorCode: notification.vendorCode,
          contractNumber: notification.contractNumber,
        },
        query: {
          notificationId: id,
        },
      }
    }

    if (isAnnouncement) {
      return {
        path: PATH_ANNOUNCEMENT_VIEW,
        params: {
          announcementId: notification.mappingId,
        },
        query: {
          notificationId: id,
        },
      }
    }
  }

  return (
    <>
      <Media
        style={{
          boxShadow: 'none',
          backgroundColor: isRead ? '#fff' : '#f5f8ff',
        }}
        icon={icon}
      >
        <Text color="#000000" size={16} bold={!notification.isRead}>
          {title}
        </Text>
        <Text color="#a3a3a3" paddingBottom={10}>
          {displayDate}
        </Text>
        {renderContent()}
        <Link {...resolveRouter()}>
          <Button variant="link" underline>
            View details
          </Button>
        </Link>
      </Media>
    </>
  )
}

NotificationItem.propTypes = {
  notification: PropTypes.instanceOf(Notification),
}

NotificationItem.defaultProps = {
  notification: new Notification(),
}

export default NotificationItem
